// Vue
import { Vue, Component } from "vue-property-decorator";
// Mobx
import { Observer } from "mobx-vue";
// Template
import template from "./template.vue";
// Base Module
import ModuleBase from "#/common/ModuleBase";
// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import { ModelSelectionModuleButton } from "./button/ModelSelectionModuleButton";
import { ModelSelectionModuleItem } from "./item/ModelSelectionModuleItem";
// ViewModel
import { ViewModel } from "./ViewModel";
import { uuid } from "#/common/Utils";
import { Api } from "#/api";
import { addTokenParameter } from "../../../common/Utils";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ModelSelectionModuleButton,
    ModelSelectionModuleItem,
  },
})
export class ModelSelectionModule extends ModuleBase {
  private allLoaded: boolean = false;

  private viewModel: ViewModel = new ViewModel();

  private fahrzeugModellOpenState: any = {};

  public async created() {
    this.allLoaded = await this.viewModel.loadModuleData(this.instance);
  }

  public getBackgroundColorFromInstance(instance: object) {
    return "white";
  }

  private handleToggleSelectionModule() {
    this.$store.selectionFilter.handleToggleSelectionModule();
  }

  get technikAufrufenLink() {
    if (
      this.instance["links"]["technik_aufrufen"] &&
      this.instance["links"]["technik_aufrufen"]["href"] &&
      this.instance["links"]["technik_aufrufen"]["access_allowed"]
    ) {
      return this.instance["links"]["technik_aufrufen"]["href"];
    } else {
      return undefined;
    }
  }

  get aufbaurichtlinienLink() {
    if (
      this.instance["links"]["aufbaurichtlinien"] &&
      this.instance["links"]["aufbaurichtlinien"]["href"] &&
      this.instance["links"]["aufbaurichtlinien"]["access_allowed"]
    ) {
      return this.instance["links"]["aufbaurichtlinien"]["href"];
    } else {
      return undefined;
    }
  }

  get abhInfoLink() {
    if (
      this.instance["links"]["abh_info"] &&
      this.instance["links"]["abh_info"]["href"] &&
      this.instance["links"]["abh_info"]["access_allowed"]
    ) {
      return this.instance["links"]["abh_info"]["href"];
    } else {
      return undefined;
    }
  }

  get informationenLink() {
    if (
      this.instance["links"]["informationen"] &&
      this.instance["links"]["informationen"]["href"] &&
      this.instance["links"]["informationen"]["access_allowed"]
    ) {
      return this.instance["links"]["informationen"]["href"];
    } else {
      return undefined;
    }
  }

  private async onClickTechnikAufrufen(flkNr) {
    let token = uuid();
    await Api.katalogService.updateSession(token, { klasse: flkNr });
    window.location.href = addTokenParameter(this.technikAufrufenLink, token);
  }

  private async onClickAufbaurichtlinien(flkNr) {
    let token = uuid();
    await Api.katalogService.updateSession(token, { klasse: flkNr });
    window.location.href = addTokenParameter(this.aufbaurichtlinienLink, token);
  }

  private async onClickAbhInfo(flkNr) {
    let token = uuid();
    await Api.katalogService.updateSession(token, { klasse: flkNr });
    window.location.href = addTokenParameter(this.abhInfoLink, token);
  }

  private async onClickInformationen(flkNr) {
    let token = uuid();
    await Api.katalogService.updateSession(token, { klasse: flkNr });
    window.location.href = addTokenParameter(this.informationenLink, token);
  }

  private onExpandFahrzeugModel(fahrzeugModell) {
    if (this.fahrzeugModellOpenState[fahrzeugModell.key]) {
      Vue.set(
        this.fahrzeugModellOpenState,
        fahrzeugModell.key,
        !this.fahrzeugModellOpenState[fahrzeugModell.key]
      );
    } else {
      Vue.set(this.fahrzeugModellOpenState, fahrzeugModell.key, true);
    }
  }

  private isExpanded(fahrzeugModell) {
    if (this.fahrzeugModellOpenState[fahrzeugModell.key] == undefined) {
      Vue.set(this.fahrzeugModellOpenState, fahrzeugModell.key, false);
    }

    return this.fahrzeugModellOpenState[fahrzeugModell.key];
  }
}
